import { InputCheckbox, ListItem, Stack, Text } from "@bookingcom/bui-react";
import type { UserAirlineGroupAirline } from "../../types";
import styles from "./AirlineGroupSelector.module.css";

type AirlineGroupSelectorAirlineListItemProps = {
  airline: UserAirlineGroupAirline;
  isGrouped?: boolean;
  isSelected?: boolean;
  disabled?: boolean;
  onChange?: () => void;
};

export const AirlineGroupSelectorAirlineListItem = ({
  airline,
  isGrouped = false,
  isSelected = false,
  disabled = false,
  onChange,
}: AirlineGroupSelectorAirlineListItemProps) => {
  const { name, code } = airline;

  return (
    <ListItem spacing="small" className={styles.listItem}>
      <Stack
        mixin={{ padding: 3, paddingInlineStart: isGrouped ? 7 : 3 }}
        className={isSelected ? styles.listItemSelected : undefined}
      >
        <InputCheckbox
          className={styles.listItemCheckbox}
          name={`airline-${code}`}
          label={
            <Stack direction="row">
              <Text variant="body_2" color="neutral_alt">
                {code}
              </Text>
              <Text variant="emphasized_2">{name}</Text>
            </Stack>
          }
          checked={isSelected}
          disabled={disabled}
          onChange={onChange}
        />
      </Stack>
    </ListItem>
  );
};
